/*! @pentacode/ui v0.1.0 */
import { FormElement as e } from "./elements/formElement.js";
import { t } from "./styledElement-DUAqv8gi.js";
import { t as n } from "./css-build-DcREbovZ.js";
import { t as r } from "./decorateMetadata-BXz2gmG4.js";
import { t as i } from "./decorate-C_HUHFGG.js";
import { LitElement as a, html as o } from "lit";
import { customElement as s, property as c, state as l } from "lit/decorators.js";
import { createRef as u, ref as d } from "lit/directives/ref.js";
// \0lit-plugin:css-sheet:./src/elements/textarea/textarea.css.js
var f = n(":host{--outline-color:var(--grey);--outline-focus-color:var(--primary);--scrollbar-color:var(--primary);--text-area-padding:.5em;--_textbox-radius:var(--radius-relative);--_textbox-scrollbar-width:8px;background-color:var(--surface-document);border-radius:var(--_textbox-radius);outline:1px solid var(--outline-color);transition:outline .1s}:host(:focus),:host(:focus-within){outline-width:2px;outline-color:var(--outline-focus-color)}::selection{background-color:var(--primary);color:var(--white)}[part=container-wrapper]{border-radius:inherit}[part=container]{max-height:calc(var(--_textarea-max-rows) * 1lh);display:grid;overflow:auto}@supports (scrollbar-color:auto){[part=container]{scrollbar-width:thin}}@supports selector(::-webkit-scrollbar){[part=container]::-webkit-scrollbar{width:var(--_textbox-scrollbar-width)}[part=container]::-webkit-scrollbar-track{background:var(--light-grey)}[part=container]::-webkit-scrollbar-thumb{background-color:var(--scrollbar-color);border-radius:calc(var(--_textbox-scrollbar-width) / 2);border:clamp(2px, calc(var(--_textbox-scrollbar-width) - 10px), 6px) solid var(--light-grey)}}[part=container]{clip-path:inset(0 round var(--_textbox-radius))}[part=container]:after{content:attr(data-replicated-value) \" \";white-space:pre-wrap;overflow-wrap:anywhere;visibility:hidden}[part=textarea]{resize:none;color:inherit;background:0 0;overflow:hidden}[part=textarea]:focus{outline:none}[part=textarea],[part=container]:after{font:inherit;padding:var(--text-area-padding);border:none;grid-area:1/1/2/2}"), p = class extends t(e(a)) {
	constructor(...e) {
		super(...e), this.styles = f, this.rows = 1, this.maxRows = 5, this.autoGrow = !1, this.placeholder = "", this.disabled = !1, this.replicatedValue = " ", this._value = "", this._textareaRef = u();
	}
	get value() {
		return this._value;
	}
	set value(e) {
		this._value = e ?? "";
	}
	connectedCallback() {
		super.connectedCallback(), this.value = this.textContent?.trim() || "", this._setReplicatedValue(), this.internals.setFormValue(this.value);
	}
	_setReplicatedValue() {
		queueMicrotask(() => {
			this.replicatedValue = this.value === "" ? " " : this.value;
		});
	}
	_handleInput(e) {
		let t = e.target.value;
		this._setReplicatedValue(), this.value = t;
	}
	_handleChange(e) {
		let t = e.target.value;
		this.value = t, this._setReplicatedValue(), this.internals.setFormValue(t);
	}
	focus() {
		this._textareaRef.value?.focus();
	}
	clear() {
		this.value = "", this._setReplicatedValue(), this.internals.setFormValue(""), this._textareaRef.value.value = "";
	}
	render() {
		return o`<div part="container-wrapper">
            <div
                role="textbox"
                part="container"
                data-replicated-value=${this.replicatedValue}
                style=${this.autoGrow ? `--_textarea-max-rows: ${this.maxRows};` : ""}
            >
                <textarea
                    autocomplete="off"
                    placeholder=${this.placeholder}
                    @input=${this._handleInput}
                    @change=${this._handleChange}
                    part="textarea"
                    .rows=${this.rows}
                    .disabled=${this.disabled}
                    ${d(this._textareaRef)}
                >
${this.value}</textarea
                >
            </div>
        </div>`;
	}
};
i([c({ type: Number }), r("design:type", Object)], p.prototype, "rows", void 0), i([c({ type: Number }), r("design:type", Object)], p.prototype, "maxRows", void 0), i([c({
	type: Boolean,
	attribute: "auto-grow",
	reflect: !0
}), r("design:type", Object)], p.prototype, "autoGrow", void 0), i([c({ type: String }), r("design:type", String)], p.prototype, "placeholder", void 0), i([c({ type: Boolean }), r("design:type", Boolean)], p.prototype, "disabled", void 0), i([l(), r("design:type", String)], p.prototype, "replicatedValue", void 0), i([
	c({
		type: String,
		attribute: !1,
		reflect: !1
	}),
	r("design:type", String),
	r("design:paramtypes", [String])
], p.prototype, "value", null), p = i([s("ptc-ui-textarea")], p);
var m = p;
export { m as n, p as t };

//# sourceMappingURL=textarea-Cyvwmldp.js.map